import "./AppointmentsListComponent.scss";
import CardComponent from "../../shared/components/card/CardComponent";
import {ITableColumn} from "../../shared/models/table.model";
import {useMemo, useState} from "react";
import {APIConfig} from "../../constants";
import {CommonService} from "../../shared/services";
import TableWrapperComponent from "../../shared/components/table-wrapper/TableWrapperComponent";
import LinkComponent from "../../shared/components/link/LinkComponent";
import SelectDropdownComponent from "../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import moment from "moment";
import ButtonComponent from "../../shared/components/button/ButtonComponent";
import ChipComponent from "../../shared/components/chip/ChipComponent";
import ToolTipComponent from "../../shared/components/tool-tip/ToolTipComponent";
import ModalComponent from "../../shared/components/modal/ModalComponent";
import SecureCheckoutComponent from "../transaction/secure-checkout/SecureCheckoutComponent";
import DateRangePickerComponentV2 from "../../shared/components/date-range-pickerV2/DateRangePickerComponentV2";
import momentTimezone from "moment-timezone";
import {useNavigate} from "react-router-dom";

interface AppointmentsListComponentProps {
    upcomingAppointment?: any;
}

const AppointmentsListComponent = (props: AppointmentsListComponentProps) => {

    const [appointmentFilterData, setAppointmentFilterData] = useState<any>({
        provider_id: undefined,
        status: undefined,
        date_range: [null, null],
        start_date: null,
        end_date: null,
    });
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState<string>('');
    const [isSecureCheckOutModalOpen, setIsSecureCheckOutModalOpen] = useState<boolean>(false);
    const [refreshToken, setRefreshToken] = useState<string>('');

    const {
        allProvidersList,
        isAllProvidersListLoaded,
        isAllProvidersListLoading
    } = useSelector((state: IRootReducerState) => state.user);

    const {
        appointmentStatusList,
        isAppointmentStatusListLoaded,
        isAppointmentStatusListLoading
    } = useSelector((state: IRootReducerState) => state.staticData);

    const columns: ITableColumn[] = useMemo<ITableColumn[]>(() => [
        {
            title: "Date",
            key: "date",
            dataIndex: "name",
            fixed: "left",
            align: "center",
            width: 130,
            render: (record: any) => <span>{CommonService.getSystemFormatTimeStamp(record?.appointment_date)}</span>
        },
        {
            title: "Time",
            key: "time",
            dataIndex: "time",
            align: "center",
            width: 160,
            render: (record: any) => <span>{CommonService.getHoursAndMinutesFromMinutes(record?.start_time)}</span>
        },
        {
            title: "Service Name",
            key: "service_name",
            dataIndex: "name",
            align: "center",
            width: 180,
            render: (record: any) =>
                <>
                    <ToolTipComponent tooltip={<>
                        {record?.category_details ? record?.category_details?.name : 'N/A'}<br/> {record?.service_details?.name}
                    </>
                    }>
                        <div>{CommonService.getFirstLetterOfEachWord(record?.category_details?.name) + (record?.category_details?.name?.length ? " - " : '') + CommonService.truncateName(record?.service_details?.name, 15)}</div>
                    </ToolTipComponent>
                </>
        },
        {
            title: "Provider Name",
            key: "provider_name",
            dataIndex: "provider_name",
            align: "center",
            width: 180,
            render: (record: any) =>
                <span>{record?.provider_details?.first_name} {record?.provider_details?.last_name}</span>
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            align: "center",
            width: 150,
            render: (record: any) => <ChipComponent className={record?.status_details?.code}
                                                    label={record?.status_details?.client_title === 'No Show' ? 'no_show' : record?.status_details?.client_title}/>
        },
        {
            title: "Forms",
            key: "forms",
            dataIndex: "forms",
            align: "center",
            width: 150,
            render: (record: any) => {
                return (
                    <div>
                        {record?.is_forms_filled === undefined || record?.is_forms_filled === null
                            ? 'No Forms'
                            : record?.is_forms_filled
                                ? 'Completed'
                                : (
                                    <ButtonComponent size="small" variant="outlined"
                                                     onClick={() => navigate(CommonService._routeConfig.ClientOnboarding() + '?appointmentId=' + record?._id)}
                                                     disabled={record?.status === 'canceled' || record?.status === 'no_show'}
                                                     color="accent">
                                        Fill/Review Forms
                                    </ButtonComponent>
                                )}

                    </div>
                )
            }

        },
        {
            title: 'Payments',
            key: "payments",
            dataIndex: "payments",
            align: "center",
            render: (record: any) => {
                return (
                    <div>
                        {record?.payment_status === 'unpaid' ? <ButtonComponent size={'small'}
                                                                                onClick={() => {
                                                                                    if (record?.enable_pay_now===false) {
                                                                                        CommonService._alert.showToast('This appointment has been marked as cancelled or no-show. Payment is not allowed unless the status is updated by the admin.')
                                                                                    } else {
                                                                                        setSelectedId(record?.invoice_details?._id);
                                                                                        setIsSecureCheckOutModalOpen(true);
                                                                                    }
                                                                                }}
                                                                                variant={'outlined'}
                                                                                color={'error'}>
                            Pay Now
                        </ButtonComponent> : CommonService.capitalizeFirstLetter(record?.payment_status)}
                    </div>
                )
            }

        },
        {
            title: "Action",
            key: "view_details",
            dataIndex: "view_details",
            align: "center",
            fixed: "right",
            width: 120,
            render: (record: any) => {
                return (
                    <LinkComponent route={CommonService._routeConfig.AppointmentDetails(record?._id)}>
                        View Details
                    </LinkComponent>
                );
            }
        },
    ], [navigate]);

    return (
        <div className={'appointments-list-component'}>
            <CardComponent className={'appointments-list-filters-container-card'}>
                <div className="appointments-list-filters ts-row">
                    <div className="ts-col">
                        <SelectDropdownComponent
                            size={"small"}
                            placeholder={"Provider"}
                            value={appointmentFilterData.provider_id}
                            options={allProvidersList}
                            displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.first_name)} ${CommonService.capitalizeFirstLetter(option?.last_name)}`}
                            valueExtractor={(option: any) => option._id}
                            isDataLoading={isAllProvidersListLoading}
                            isDataLoaded={isAllProvidersListLoaded}
                            onUpdate={(value: any) => {
                                setAppointmentFilterData({
                                    ...appointmentFilterData,
                                    provider_id: value
                                });
                            }}
                        />
                    </div>
                    <div className="ts-col">
                        <SelectDropdownComponent
                            size={"small"}
                            options={appointmentStatusList}
                            placeholder={"Status"}
                            value={appointmentFilterData.status}
                            displayWith={(option: any) => option?.client_title}
                            valueExtractor={(option: any) => option?.code}
                            isDataLoading={isAppointmentStatusListLoading}
                            isDataLoaded={isAppointmentStatusListLoaded}
                            onUpdate={(value: any) => {
                                setAppointmentFilterData({
                                    ...appointmentFilterData,
                                    status: value
                                });
                            }}
                        />
                    </div>
                    <div className="ts-col">

                    </div>
                    <div className="ts-col">
                        <DateRangePickerComponentV2
                            value={appointmentFilterData.date_range}
                            onDateChange={(value: any) => {
                                setAppointmentFilterData((prevState: any) => {
                                    if (value) {
                                        return {
                                            ...prevState,
                                            start_date: moment(value[0]).format('YYYY-MM-DD'),
                                            end_date: moment(value[1]).format('YYYY-MM-DD'),
                                            date_range: value,
                                            timezone: momentTimezone.tz.guess()
                                        };
                                    } else {
                                        const {date_range, start_date, end_date, ...rest} = prevState;
                                        return rest;
                                    }
                                });
                            }}
                        />
                    </div>
                </div>
                <TableWrapperComponent
                    columns={columns}
                    method={APIConfig.GET_MY_APPOINTMENTS.METHOD}
                    url={APIConfig.GET_MY_APPOINTMENTS.URL}
                    refreshToken={refreshToken}
                    extraPayload={appointmentFilterData}
                    noDataText={
                        (
                            appointmentFilterData.provider_id ||
                            appointmentFilterData.status ||
                            (appointmentFilterData.start_date || appointmentFilterData.end_date)
                        )
                            ? 'No appointment was found for the applied filter.' : 'No appointments have been booked.'

                    }
                />
            </CardComponent>
            <ModalComponent isOpen={isSecureCheckOutModalOpen}>
                <SecureCheckoutComponent isComingFromListScreen={true}
                                         selectedId={selectedId}
                                         location={'appointmentList'}
                                         setRefreshToken={setRefreshToken}
                                         setIsSecureCheckOutModalOpen={setIsSecureCheckOutModalOpen}/>
            </ModalComponent>
        </div>
    );

};

export default AppointmentsListComponent;
